/*********************************************************************************************************************************
 This class has been automatically generated using KLTT-APIRestGenerator project, don't do manual file modifications.
 Mon Oct 22 12:45:25 CEST 2018

 "Licensed to the Apache Software Foundation (ASF) under one or more contributor license agreements;
  and to You under the Apache License, Version 2.0. "
**********************************************************************************************************************************/


/** 
 * This exception will return an array of longs (two dimensions)
 */
export class ExampleLongException492
{
	/**
	 * @param bodyExceptionMessage with the body exception message
	 */
	constructor(private bodyExceptionMessage: number[][])
    {
		// Empty constructor
    }

	/**
	 * @return the bodyExceptionMessage
	 */
	getBodyExceptionMessage()
	{
		return this.bodyExceptionMessage ;
	}

	/**
	 * @return the object as string
	 */
	toString()
	{
		return JSON.stringify(this, null, 4) ;
	}
} ;
